import { initializeApp } from 'firebase/app'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getAuth, GoogleAuthProvider, OAuthProvider, connectAuthEmulator } from 'firebase/auth';
// Analytics initialized for side effects
import { getAnalytics } from 'firebase/analytics'
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage } from 'firebase/storage';

// Local emulators (auth/firestore/functions) under a `demo-` project, which
// the SDKs never route to real backends. Off unless VITE_USE_EMULATORS=true.
const USE_EMULATORS = import.meta.env.VITE_USE_EMULATORS === 'true'

const firebaseConfig = {
  apiKey: 'AIzaSyAtj57rMMbgHMTcfx9uYY-bZLxthNryA40',
  authDomain: 'app.vysual.com',
  projectId: 'the-portal-e8fd3',
  storageBucket: 'the-portal-e8fd3.appspot.com',
  messagingSenderId: '482010361961',
  appId: '1:482010361961:web:e4b25740d975808239b2f8',
  measurementId: 'G-QCRVRNV25B'
}

const app = initializeApp(USE_EMULATORS
  // No storage emulator: point Storage at a demo bucket so nothing reaches prod.
  ? { ...firebaseConfig, projectId: 'demo-vysual', storageBucket: 'demo-vysual.appspot.com' }
  : firebaseConfig)

const _analytics = USE_EMULATORS ? null : getAnalytics(app)
const db = getFirestore(app)
const auth = getAuth(app);
const storage = getStorage(app);
// Direct getFunctions() callers elsewhere resolve to this same default-app,
// us-central1 instance, so the emulator connection below covers them too.
const functions = getFunctions(app);

if (USE_EMULATORS) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true })
  connectFirestoreEmulator(db, '127.0.0.1', 8080)
  connectFunctionsEmulator(functions, '127.0.0.1', 5001)
}

const googleProvider = new GoogleAuthProvider();
const microsoftProvider = new OAuthProvider('microsoft.com');

export { db, auth, functions, storage, googleProvider, microsoftProvider };
